import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
	requestPageOfCases,
	searchData,
	searchSortData
} from "../CaseSelector/store/actions";
import "../CaseSelector/CaseSelector.css";
import "./Admin.css";
import axios from "axios";
import { apiUri } from "../../config";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";

class ManagingPurchases extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			searchArray: [],
			currentCases: [],
			sortValue: "",
			sortOrder: "",
			firmsArray: [],
			firmsArrayOld: [],
			checkToggle: false
		};

		this.getFirmsData = this.getFirmsData.bind(this);
		this.handleActivation = this.handleActivation.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.updateSearchValue = this.updateSearchValue.bind(this);
		this.goToCaseHandler = this.goToCaseHandler.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleClear = this.handleClear.bind(this);
	}

	goToCaseHandler = caseId => {
		this.props.history.push("/cases/" + caseId);
	};
	handleEdit = caseId => {};
	handleSorting = (key, order) => {
		this.setState({ sortValue: key, sortOrder: order });
		let obj = {
			sortValue: key,
			sortOrder: order
		};
		localStorage.setItem("sortParams", JSON.stringify(obj));
		this.props.searchSortData(this.props.currentPage, key, order);
	};
	componentWillMount() {
		this.getFirmsData().then(value => {
			this.state.firmsArray.forEach(element => {
			element.openToggle = false;
			});
		});
	}
	getFirmsData(s, f) {
		return new Promise((resolve, reject) => {
			axios
			.get(apiUri + "/firms/getAllFirms")
			.then(json => {
				if (json && json.data.statusCode === 200 && json.data.content) {
				let data = json.data.content;
				data.forEach(element => {
					element.name = element.id.replace("/", "");
				});
				this.setState({ firmsArray: data });
				}
				resolve();
			})
			.catch(err => {
				console.log(err);
				reject();
			});
		});
	}
	componentDidMount() {
		this.props.requestPageOfCases(
			this.props.currentPage,
			this.state.sortValue,
			this.state.sortOrder
		);
	}
	updateSearchValue(evt) {
		this.setState({ searchValue: evt.target.value });
		this.setState({ searchValue: evt.target.value });
	}
	handleClick(evt) {
		localStorage.setItem("searchValue", JSON.stringify(this.state.searchValue));
		this.props.searchData(this.props.currentPage);
		this.props.searchData(this.props.currentPage);
	}
	handleToggle(evt, data) {
		let self = this;
		this.state.firmsArray.forEach(element => {
			if (element.name === data.name) {
				element.openToggle = !element.openToggle;
				this.setState({ firmsSubArray: data });
				if (element.openToggle) {
					axios
					.post(apiUri + "/purchases/byCompany", { companyId: data.id })
					.then(json => {
						if (
							json &&
							json.data &&
							json.data.statusCode === 200 &&
							json.data.content
						) {
							let subData = json.data.content;
							self.state.firmsArray.forEach(ele => {
								if (element.name === data.name) {
									if (subData && subData.length > 0) {
										element.subBlock = subData;
										this.setState({ firmsSubArray: data });
										this.setState({ firmsSubArray: data });
									}
								}
							});
						}
					})
					.catch(err => {
						console.log(err);
					});
				}
			} else {
				element.openToggle = false;
			}
		});
	}
	handleClear() {
		this.setState({ searchValue: "" });
		localStorage.removeItem("searchValue");
		this.props.searchData(this.props.currentPage);
	}
	handleActivation(firm, data, val) {
		let self = this;
		if (data.purchaseStatus !== val) {
			var requestData = {};
			var url = "";
			if (data.type === "commission") {
				url = "/purchases/commission/status";
				requestData = {
					id: data.caseId,
					purchaseStatus: val
				};
			} else {
				url = "/purchases/status";
				requestData = {
					customerOwnerId: data.customerOwnerId,
					caseId: data.caseId,
					purchaseStatus: val
				};
			}
			axios
			.post(apiUri + url, requestData)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					this.refreshFirmsData(self);
				}
			})
			.catch(err => {
				console.log(err);
			});
		}
	}

	refreshFirmsData(self) {
		self.setState({ firmsArrayOld: self.state.firmsArray });

		self.getFirmsData().then(val => {
			for (let i = 0; i < self.state.firmsArrayOld.length; i++) {
				if (self.state.firmsArrayOld[i].id === self.state.firmsArray[i].id) {
					self.state.firmsArray[i].openToggle =
					self.state.firmsArrayOld[i].openToggle;
					if (self.state.firmsArray[i].openToggle) {
						self
							.getSubData(self.state.firmsArray[i], self.state.firmsArrayOld[i])
							.then(val1 => {
							self.state.firmsArray[i] = val1;
							self.setState({ checkToggle: true });
							return;
							});
					}
				}
			}
		});
	}

	getSubData(val, old) {
		const element = old;
		let self = this;
		return new Promise((resolve, reject) => {
			axios
			.post(apiUri + "/purchases/byCompany", { companyId: val.id })
			.then(json => {
				
				if (json && json.data && json.data.statusCode === 200) {
					let subData = json.data.content;
					self.state.firmsArray.forEach(ele => {
						if (element.name === val.name) {
							if (subData && subData.length > 0) {
								val.subBlock = subData;
							}
						}
					});
					self.setState({ checkToggle: true });
					resolve(val);
				}
			})
			.catch(err => {
				console.log(err);
				reject();
			});
		});
	}
		keyPress(e) {
		if (e.keyCode === 13 || e.keyCode === 10) {
			this.handleClick();
		}
	}

	getProperDate = data => {
 
		var data1 =[]
		for(let i=0;i<3;i++){
			data1[i]=data[i]
		}
		if (data1) {
			var date = new Date(data1);
			var year = date.getFullYear();
			var month = (1 + date.getMonth()).toString().padStart(2, "0");
			var day = date
				.getDate()
				.toString()
				.padStart(2, "0");
			return month + "/" + day + "/" + year;
		} else {
			return "";
		}

	};

	render() {
	return (
		<React.Fragment>
		<div
			style={{ display: "flex", justifyContent: "space-between" }}
			className={"ManagingPurchasesTitle"}
		>
			<span>Managing Purchases</span>
		</div>
		{this.state.firmsArray.map((firm, i) => {
			return (
			<div key={i}>
				<div className={firm.openToggle ? "firmBlockOpen" : "firmBlock"}>
				<label>{firm.name}</label>
				<span className="toggleArrow">
					{!firm.openToggle && (
					<FaChevronRight
						onClick={evt => {
						this.handleToggle(evt, firm);
						}}
					/>
					)}
					{firm.openToggle && (
					<FaChevronDown
						onClick={evt => {
						this.handleToggle(evt, firm);
						}}
					/>
					)}
				</span>
				</div>

				{firm.openToggle &&
				(firm.subBlock !== undefined && firm.subBlock.length > 0 ? (
					<div className="firmSubBlock">
					<table className="firmTable">
						<thead >
						<tr>
							<th width="13%">Filing Name</th>
							<th width="10%">Docket Number</th>
							<th width="10%">Commission Level</th>
							<th width="10%">Purchase User</th>
							 <th width="10%">Purchase Type</th> 
							 <th width="10%">Purchase Date</th>
							<th width="1%">Purchase Status</th>
						</tr>
						</thead>
						<tbody>
						{firm.subBlock.map((sub, j) => {
							var index = sub.purchaseType.indexOf("_");  
							var id = sub.purchaseType.substr(0, index+1); 
							var text = sub.purchaseType.substr(index + 1);
							
							var purchase_date = this.getProperDate(sub.purchaseTime)
					
							return (
							<tr key={j}>
								<td>
								<label>{sub.fillingName}</label>
								</td>
								<td>
								<label>{sub.docketNumber}</label>
								</td>
								<td>
								<label>{sub.commissionLevel}</label>
								</td>
								<td>
								<label>{sub.userEmail}</label>
								</td>
								
								<td >
								<label >{id }<br></br>{text}</label> 
								</td>
								<td>
								<label>{purchase_date}</label>
								</td>
								<td>
								<div className="relativePos">
									<select
									className="subFirmSelect"
									value={sub.purchaseStatus}
									onChange={evt => {
										this.handleActivation(
										firm,
										sub,
										evt.target.value
										);
									}}
									>
									<option>-- Select --</option>
									<option value="REQUESTED">Requested</option>
									<option value="ANALYSIS">
										Case Analysis
									</option>
									<option value="BILLED">
										Billing generated
									</option>
									<option value="PAID">Payment Done</option>
									</select>
								</div>
								</td>
							</tr>
							);
						})}
						</tbody>
					</table>
					</div>
				) : (
					<div className="firmSubBlock">
					<div className="subBlock">
						<p className="noData">No purchase history.</p>
					</div>
					</div>
				))}
			</div>
			);
		})}
		</React.Fragment>
	);
	}
}

const mapStateToProps = state => {
	return {
	currentCases: state.cases.currentCases,
	currentPage: state.cases.currentPage,
	totalCases: state.cases.totalCases,
	totalPages: state.cases.totalPages
	};
};

const mapDispatchToProps = dispatch => {
	return {
	requestPageOfCases: (page, sortValue, sortOrder) =>
		dispatch(requestPageOfCases(page, sortValue, sortOrder)),
	searchData: page => dispatch(searchData(page)),
	searchSortData: (currentPage, sortValue, sortOrder) =>
		dispatch(searchSortData(currentPage, sortValue, sortOrder))
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(ManagingPurchases));



// WEBPACK FOOTER //
// ./src/components/Admin/ManagingPurchases.js